<template lang="html">
  <PlpShell :search-query="query" />
</template>

<script setup lang="ts">
/**
 * Free-text query listing — shared PlpShell, query scope.
 * Used by `/search?q=` (canonical) and legacy `/catalog?q=`.
 * Noindex via seoRoot. No cross-category facets.
 */
import PlpShell from '#Products/components/Catalog/PlpShell.vue'

const props = defineProps<{
  query: string
}>()

useSeoMeta({
  title: () => (props.query ? `Поиск по «${props.query}»` : 'Поиск'),
})
</script>
